module.exports = "/_next/static/images/img__offer-1_desktop-c3dce72357f2065c744df64c76eebd58.png";